import { apiClient } from '../../utils';
import handleSagaError from '../../redux/handleSagaError';
import { handleError } from '../handleError';
import { postChainRemoveModes as modes } from '../../config';

export const removePost = ({ tp, pci, psi }) =>
  pci &&
  tp &&
  new Promise((resolve, reject) =>
    apiClient
      .post(`/postChain${modes[tp].ep}`, {
        data: { pci, ...(modes[tp].psi ? { psi } : {}) },
      })
      .then(resolve)
      .catch((e) => {
        reject(e);
        handleError(e);
      })
  );

/*
  1: حذف پست از یونید
  2: حذف پست از سایت شخصی
  3: حذف پست چین
*/
